import { Inject, Injectable } from "@angular/core";
import { AbstractService } from "./abstract-service.service";
import { Product } from "../Models/product";
import { HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import { SKIP_LANG_PARAM } from "./http/language.interceptor";

import { APP_CONFIG, AppConfig } from "./config";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { Response } from "../Models/response";
import { catchError, map } from "rxjs/operators";
import { Page } from "../Models/page";
import { Router } from "@angular/router";

export class PriceField {
  minPrice: number;
  maxPrice: number;
  constructor(minPrice: number, maxPrice: number) {
    this.maxPrice = maxPrice;
    this.minPrice = minPrice;
  }
}

@Injectable({
  providedIn: "root",
})
export class ProductService extends AbstractService<Product, number> {
  url: string;
  url_: string;
  public mySubject = new BehaviorSubject<PriceField | null>(null);

  public myMaxPrice = new BehaviorSubject<number>(0);
  constructor(
    http: HttpClient,
    @Inject(APP_CONFIG) config: AppConfig,
    private router: Router,
  ) {
    super(http);
    this.url = `${config.apiEndpoint}/new/products`;
    this.url_ = `${config.apiEndpoint}/new/product-configurations/guichet/search-activated`;
  }

  public productById(id: number): Observable<Product> {
    const url = `${this.url}/guichet/${id}`;
    return this.http.get<Product>(url).pipe(
      map((response: Product): Product => {
        return response;
      }),
      catchError((error) => {
        console.error("❌ Erreur lors du chargement du produit:", error);
        // tu peux renvoyer un observable vide pour éviter un crash
        return of({} as Product);
      }),
    );
  }

  public getByFilter(
    filter: {
      id?: number;
      minPrice?: string;
      maxPrice?: string;
      brands?: string[];
      orderBy?: string;
      query?: string;
      inStock?: string;
      state?: string;
    },
    categories?: number[],
    page: number = 0,
    size: number = 5,
    /** search without the `lang` parameter (header search bar) */
    withoutLang: boolean = false,
  ): Observable<Page<any>> {
    let params = new HttpParams()
      .set("pageNo", page.toString())
      .set("pageSize", size.toString());

    if (categories && categories.length > 0) {
      const validCategories = categories.filter(
        (cat) => cat != null && cat !== 0 && !isNaN(cat),
      );
      validCategories.forEach((cat) => {
        params = params.append("category", cat.toString());
      });
    }

    if (filter.maxPrice) params = params.append("max-price", filter.maxPrice);
    if (filter.minPrice) params = params.append("min-price", filter.minPrice);
    if (filter.brands) {
      params = params.append("brands", filter.brands.toString());
    }
    if (filter.orderBy) params = params.append("orderBy", filter.orderBy);
    if (filter.query) params = params.append("query", filter.query);
    if (filter.inStock) params = params.append("inStock", filter.inStock);
    if (filter.state) params = params.append("state", filter.state);
    const url = this.url_;
    const context = new HttpContext().set(SKIP_LANG_PARAM, withoutLang);
    return this.http.get<Page<any>>(url, { params, context });
  }

  public availableProducts(
    pageNo = 0,
    pageSize = 10,
  ): Observable<Response<Page<Product>>> {
    const url = `${this.url}/search-available`;
    let params = new HttpParams()
      .set("pageNo", pageNo.toString())
      .set("pageSize", pageSize.toString());
    return this.http.get<Response<Page<Product>>>(url, { params }).pipe(
      map((response: Response<Page<Product>>) => {
        if (response.body) {
          return response;
        } else {
          throw new Error();
        }
      }),
    );
  }
}
